module.exports = __webpack_public_path__ + "static/img/9.6fc7683.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/1/sp/9.png
// module id = WOwh
// module chunks = 0